if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');
        if (!this.submitBtn && this.form.id) {
          this.submitBtn = document.querySelector(`[name="add"][form="${CSS.escape(this.form.id)}"]`);
        }
        this.quickAddDrawer = this.closest('quick-add-drawer');

        if (this.quickAddDrawer && Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      const activeBtn = evt.submitter || this.submitBtn;
      if (!activeBtn) return;

      evt.preventDefault();
      if (activeBtn.getAttribute('aria-disabled') === 'true') return;

      this.clickedBtn = activeBtn;
      this.buyNowPending = activeBtn.hasAttribute('data-buy-now');

      if (activeBtn.dataset.connectedButton && !this.connectedBtn) {
        this.connectedBtn = document.querySelector(activeBtn.dataset.connectedButton);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable the clicked action until submission is complete.
      const toDisable = [activeBtn];
      if (this.submitBtn && this.submitBtn !== activeBtn) toDisable.push(this.submitBtn);
      if (this.form) {
        this.form.querySelectorAll('[data-card-action]').forEach((btn) => {
          if (!toDisable.includes(btn)) toDisable.push(btn);
        });
        if (this.form.id) {
          document.querySelectorAll(`[data-card-action][form="${CSS.escape(this.form.id)}"]`).forEach((btn) => {
            if (!toDisable.includes(btn)) toDisable.push(btn);
          });
        }
      }
      toDisable.forEach((btn) => {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('disabled', 'disabled');
      });
      activeBtn.classList.add('is-loading');

      if (this.connectedBtn) {
        this.connectedBtn.setAttribute('aria-disabled', 'true');
        this.connectedBtn.classList.add('is-loading');
        this.connectedBtn.setAttribute('disabled', 'disabled');
      }

      const productIdInForm = this.form.querySelector('[name="id"]').value;
      const giftWrapCheckbox = document.getElementById('gift-wrap');
      if (productIdInForm === theme.settings.giftWrapProductId && giftWrapCheckbox) {
        if (giftWrapCheckbox.checked === false) giftWrapCheckbox.click();
        this.atcCompleted();
        if (this.cartDrawer) this.cartDrawer.open();
        return;
      }

      const optionFees = this.customOptionFees();
      this.syncCustomOptionPriceInput(optionFees);
      const formData = new FormData(this.form);

      const sections = this.cartDrawer ? `${this.cartDrawer.dataset.section},cart-icon-bubble` : 'cart-icon-bubble';

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (optionFees.length) {
          const feeData = await this.addCustomOptionFees(optionFees, formData.get('quantity'), sections);
          if (feeData.sections) data.sections = feeData.sections;
        }

        if (this.buyNowPending) {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          window.location.href = (theme.routes && theme.routes.checkout) || `${root}checkout`;
          return;
        }

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          if (this.quickAddDrawer) this.quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !this.quickAddDrawer && theme.settings.afterAtc === 'drawer',
                this.submitBtn
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        this.atcCompleted();
      }
    }

    customOptionFees() {
      if (!theme.customOptionFees) return [];
      const root = this.closest('quick-add-drawer') || this.closest('.js-product') || document;
      return theme.customOptionFees(root, this.form.getAttribute('id'));
    }

    syncCustomOptionPriceInput(fees) {
      this.form.querySelectorAll('[data-custom-option-price-ids]').forEach((input) => input.remove());
      if (!fees.length) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_custom_option_price_ids]';
      input.dataset.customOptionPriceIds = 'true';
      input.value = fees.map((fee) => fee.id).join(',');
      this.form.appendChild(input);
    }

    async addCustomOptionFees(fees, quantity, sections) {
      const qty = Math.max(1, parseInt(quantity, 10) || 1);
      const counts = {};
      fees.forEach((fee) => {
        counts[fee.id] = (counts[fee.id] || 0) + qty;
      });

      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: Object.entries(counts).map(([id, itemQuantity]) => ({
            id: Number(id),
            quantity: itemQuantity,
            properties: {
              _custom_option_fee: 'true'
            }
          })),
          sections: String(sections).split(',').filter(Boolean),
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        const error = data.description || data.message || theme.strings.cartError;
        this.setErrorMsgState(error);
        throw new Error(response.status || data.status);
      }
      return data;
    }

    atcCompleted() {
      const btn = this.clickedBtn || this.submitBtn;
      if (!btn) return;

      // Re-enable the button that was clicked.
      btn.classList.add('is-success');
      btn.removeAttribute('aria-disabled');
      setTimeout(() => {
        btn.classList.remove('is-loading');
        btn.classList.remove('is-success');
        btn.removeAttribute('disabled');
      }, 1400);

      const partners = [];
      if (this.form) {
        this.form.querySelectorAll('[data-card-action][disabled]').forEach((partner) => partners.push(partner));
        if (this.form.id) {
          document.querySelectorAll(`[data-card-action][form="${CSS.escape(this.form.id)}"][disabled]`).forEach((partner) => {
            if (!partners.includes(partner)) partners.push(partner);
          });
        }
      }
      partners.forEach((partner) => {
        if (partner === btn) return;
        partner.removeAttribute('aria-disabled');
        partner.removeAttribute('disabled');
      });

      if (this.connectedBtn) {
        // Re-enable 'Add to Cart' button.
        this.connectedBtn.classList.add('is-success');
        this.connectedBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.connectedBtn.classList.remove('is-loading');
          this.connectedBtn.classList.remove('is-success');
          this.connectedBtn.removeAttribute('disabled');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = response.sections['cart-icon-bubble'] || '';
        const el = tmpl.content.querySelector('.shopify-section');
        if (el) {
          cartIconBubble.innerHTML = el.innerHTML;
        }
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });

        // Scroll to the error message if it’s out of the viewport
        this.errorMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
